module.exports = __webpack_public_path__ + "templates/installation-prompt.component.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/installation-prompt/installation-prompt.component.html
// module id = CIeN
// module chunks = 1